/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetToursResponse } from '../../models/get-tours-response';
import { KeyType } from '../../models/key-type';

export interface GetTours$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
}

export function getTours(http: HttpClient, rootUrl: string, params: GetTours$Params, context?: HttpContext): Observable<StrictHttpResponse<GetToursResponse>> {
  const rb = new RequestBuilder(rootUrl, getTours.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetToursResponse>;
    })
  );
}

getTours.PATH = '/organization-sites/{organizationSiteKey}/carrier/tours';
